export interface EducationItem {
  degree: string;
  school: string;
  location: string;
  period: string;
  gpa: string;
  highlights: string[];
}

export const EDUCATION: EducationItem[] = [
  {
    degree: "Master's Degree in Micro Technology",
    school: "Dnepropetrovsk National University Oles Honchar",
    location: "Ukraine",
    period: "2013",
    gpa: "",
    highlights: [
      "Foundation in algorithms and data structures",
      "Software engineering principles",
      "Database design and management",
    ],
  },
];
